import {handleActions} from 'redux-actions'
import * as type from './actionTypes'

//ar a:any =localStorage.getItem('insuranceInfo');

const initState = {
    inputVal:222,
    resultPremium: '',
    checkInfo: {},
    isPartialLoad:false,
}

const actions = {}

actions[type.FETACH_DATA] = (state, action) => {
    let getJson : any = localStorage.getItem('insuranceInfo');
    getJson = JSON.parse(getJson);
    let result = action.payload.result;
    let index = action.payload.index;
    let newObj;
    if(!state.resultPremium){
        newObj = {...getJson};
        newObj.coveragePackageList[index] = Object.assign({},{...getJson}.coveragePackageList[index], result)
    }else{
        newObj = {...state.resultPremium};
        newObj.coveragePackageList[index] = Object.assign({},{...state.resultPremium}.coveragePackageList[index], result)
    }
    // 更新缓存数据
    localStorage.setItem('insuranceInfo',JSON.stringify(newObj));
     console.log('存数据')

    return {
            ...state,
            resultPremium: newObj
        }
}

actions[type.INPUT_CODE] = (state, action) => {
    return {
            ...state,
            checkInfo: {...action.payload.result.checkInfo}
        }
}

actions[type.SEND_AJAXERROR] = (state, action) => {
    let { commContractId, ctplContractId}  = state.checkInfo

    return {
            ...state,
            checkInfo: {
                checkType: "500",
                commCheckCode: "",
                commContractId,
                commSequenceNo: "",
                ctplCheckCode: "",
                ctplContractId,
                ctplSequenceNo: "",
                msg: "系统超时"
            }
        }
}

actions[type.GET_LOCALSTORAGE] = (state, action) => {
    return {
            ...state,
            resultPremium: action.payload
        }
}

actions[type.SET_PARTIALLOAD] = (state, action) => {
    return {
        ...state,
        isPartialLoad: action.payload
    }
}


export const productPrice = handleActions(actions, initState)
